import React from "react";
import styled from "@emotion/styled";
import { Typography } from "../../styles";
import PropTypes from "prop-types";

const MobileSiteSearch = ({activeLanguage}) => {
	return (
		<Form
			role="search"
			action={`/${activeLanguage}/`}
			method="get">
			<InputContainer>
				<InputIcon>
					<img
						src={`${mainScript.assetPath}images/svg/icons/icon-search-dark.svg`}
						alt=""
						width="20px"
						height="20px"
					/>
				</InputIcon>
				<InputLabel>Enter your search</InputLabel>
				<Input
					type={"text"}
					name="s"
					placeholder={activeLanguage === "fr" ? "Rechercher" : "Search"}
				/>
			</InputContainer>
		</Form>
	)
}

MobileSiteSearch.propTypes = {
	activeLanguage: PropTypes.string,
};

export default MobileSiteSearch;

const Form = styled.form`
	width: 100%;
	align-items: baseline;
`;

const InputContainer = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	position: relative;
    margin-bottom: 3rem;
`;

const Input = styled.input`
	padding: 0.8rem 2rem !important;
	border-radius: 3rem !important;
	margin-bottom: 0 !important;
    border: none;
	height: 4rem;
	width: 100%;

	&::placeholder {
		font-size: 1.7rem;
		line-height: 2.4rem;
        font-weight: ${Typography.fontWeight.medium};
	}

	&:focus {
		border: 2px solid blue;
	}
`;

const InputLabel = styled.label`
	position: absolute;
	top: -2.2rem;
	visibility: hidden;
`;

const InputIcon = styled.div`
	position: absolute;
	right: 2rem;
	cursor: default;
	height: 2rem
`;
